var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("templates"))),
                      ]),
                      _c(
                        "w-sortable",
                        {
                          attrs: {
                            "target-class": "handle",
                            tag: "w-list",
                            items: _vm.templates,
                          },
                          on: {
                            drop: function ($event) {
                              return _vm.onSorted()
                            },
                          },
                        },
                        [
                          _vm._l(_vm.templates, function (template) {
                            return _c(
                              "w-list-item",
                              {
                                key: template.ID,
                                attrs: { "show-handle": "" },
                              },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(_vm._s(template.Name)),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.edit"),
                                            expression: "$ct('common.edit')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editTemplate(template)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.copy"),
                                            expression: "$ct('common.copy')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyTemplate(template)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "copy" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.delete"),
                                            expression: "$ct('common.delete')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteTemplate(template)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.addNew()
                                },
                              },
                            },
                            [
                              _c(
                                "w-list-item-text",
                                [
                                  _c(
                                    "w-link",
                                    [
                                      _c("w-fa", { attrs: { icon: "plus" } }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ct("create-new-template")
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [_c("app-purchase-inboxreader-settings")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }